import { Link } from "react-router-dom";
import Logo from "../../assets/images/logofooter1.png";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faEnvelope,
  faGlobe,
  faPhone,
  faLocationDot,
  faChevronRight,
} from "@fortawesome/free-solid-svg-icons";
import {
  faFacebookF,
  faXTwitter,
  faLinkedinIn,
  faInstagram,
} from "@fortawesome/free-brands-svg-icons";
const Footer = () => {
  const pages = [
    { name: "About Us", path: "/about-us" },
    { name: "Contact Us", path: "/contact-us" },
    { name: "Careers", path: "/career" },
    { name: "Privacy Policy", path: "/privacy-policy" },
    { name: "Refund Policy", path: "/refund-policy" },
    { name: "Terms & Conditions", path: "/terms-and-conditions" },

    { name: " WhatsApp Privacy Policy", path: "/whatsapp/privacy-policy" },
    {
      name: "WhatsApp Terms & Conditions",
      path: "/whatsapp/terms-and-conditions",
    },
    {
      name: "Remove Meta Business Profile",
      path: "/remove-meta-business-profile",
    },
  ];

  const deetyasoftServices = [
    {
      name: "Web Solution",
      path: "/web-solution",
    },
    {
      name: "Content Management System",
      path: "/content-management-system",
    },
    {
      name: "E-Commerce",
      path: "e-commerce-services",
    },
    {
      name: "CRM SCM & ERP Services",
      path: "/crm-scm-and-erp-services",
    },
    {
      name: "Mobile Application",
      path: "/mobile-application-services",
    },
    {
      name: "SEO Service",
      path: "/seo-services",
    },
    {
      name: "Application Migration",
      path: "/application-migration",
    },
    {
      name: "Technical Migration",
      path: "/technical-maintenance-services",
    },
    {
      name: "EAI service",
      path: "/eai-services",
    },
  ];

  const socialLinks = [
    {
      href: "https://www.facebook.com/share/1VNnHxXpD7/",
      icon: faFacebookF,
      bg: "bg-[#0D77AB]",
    },
    { href: " https://x.com/DeetyaSoft", icon: faXTwitter, bg: "bg-[#0D77AB]" },
    {
      href: "https://www.linkedin.com/company/deetya-soft-private-limited/",
      icon: faLinkedinIn,
      bg: "bg-[#0D77AB]",
    },
    {
      href: "https://www.instagram.com/deetyasoft?igsh=MWxrNWNtaTNhdHFlag==",
      icon: faInstagram,
      bg: "bg-[#0D77AB]",
    },
  ];
  return (
    <footer className="bg-[#0F172A]  text-white text-sm">
      {/* Main Footer Content 0F172A  ankit 012b54*/}
      <div className="grid grid-cols-1 md:grid-cols-3 lg:grid-cols-5 gap-3 px-5 md:px-7 pt-12 pb-4 border-t border-gray-800">
        {/* About Us */}

        <div className="text-gray-300 text-xs">
          <h4 className="text-lg text-white font-semibold ">About Us</h4>
          <div className=" w-20   mb  h-[2px] bg-main1 mb-3  rounded-full" />
          {/* Logo centered below heading */}
          <div className="flex justify-start pb-3 ">
            <img src={Logo} alt="IVR Services Logo" className="h-10 w-auto" />
          </div>

          <p className=" md:text-[16px] text-sm">
            Deetya Soft Pvt Ltd. delivers quality IT solutions with a focus on
            innovation and client satisfaction. Our skilled team ensures
            excellence across web, mobile, and enterprise platforms. Driven by
            technology and trust, we continue to scale new heights.
          </p>
        </div>
        {/* deetyasoft Services List */}

        <div>
          <h4 className="text-lg font-semibold  mb-2">Deetya Soft Services</h4>
          <div className=" w-20   mb  h-[2px] bg-main1 mb-3  rounded-full" />
          <ul className="text-gray-300 pl-0 space-y-1 ">
            {deetyasoftServices.map(({ name, path }, index) => (
              <li key={index}>
                <Link
                  to={path}
                  className="flex text-[15px] items-center gap-2 no-underline text-gray-300 hover:text-white cursor-pointer transition duration-200"
                >
                  <FontAwesomeIcon icon={faChevronRight} className="text-xs" />
                  {name}
                </Link>
              </li>
            ))}
          </ul>
        </div>
        {/* Other Pages */}

        <div>
          <h4 className="text-lg    font-semibold mb-2">Quick Links</h4>
          <div className=" md:w-20 w-20  h-[2px] bg-main1 mb-3  rounded-full" />
          <ul className="text-gray-300 space-y-1  ">
            {pages.map(({ name, path }, index) => (
              <li key={index}>
                <Link
                  to={path}
                  className="flex text-[15px] items-center gap-2 no-underline text-gray-300 hover:text-white cursor-pointer transition duration-200"
                >
                  <FontAwesomeIcon icon={faChevronRight} className="text-xs" />
                  {name}
                </Link>
              </li>
            ))}
          </ul>
        </div>

        {/* Contact Info ivr guru */}

        <div>
          <h4 className="text-lg  font-semibold mb-2">Deetya Soft</h4>
          <div className=" md:w-20 w-20  h-[2px] bg-main1 mb-3  rounded-full" />
          {/* Address */}
          <div className="flex text-[15px] items-start gap-2 mb-2 hover:text-white transition duration-200 ">
            <FontAwesomeIcon
              icon={faLocationDot}
              className="mt-1 text-gray-300"
            />
            <p className="text-gray-300">
              FF-06, First Floor, Mahaluxmi Square, Plot No. C-1, Abhay
              Khand-II, <br />
              Indirapuram, Ghaziabad, Uttar Pradesh - 201014
            </p>
          </div>

          {/* Phone */}
          <div className="flex items-start gap-2 hover:text-white transition duration-200 cursor-pointer">
            <FontAwesomeIcon icon={faPhone} className="mt-1 text-gray-300" />
            <span className="text-gray-300 text-[15px] group-hover:text-white">
              <strong>Phone:</strong>{" "}
              <a
                href="tel:+919015350505"
                className="no-underline text-gray-300 hover:text-white transition duration-200"
              >
                +91-9015350505
              </a>
              , <br />
              <a
                href="tel:+919717055088"
                className="no-underline text-gray-300 hover:text-white transition duration-200"
              >
                +91-9717055088
              </a>
            </span>
          </div>

          {/* Email */}
          <div className="flex items-start gap-2 hover:text-white transition duration-200 cursor-pointer">
            <FontAwesomeIcon icon={faEnvelope} className="mt-1 text-gray-300" />
            <span className="text-gray-300 text-[15px] group-hover:text-white">
              <strong>Email:</strong>{" "}
              <a
                href="mailto:info@deetyasoft.com"
                className="no-underline text-gray-300 hover:text-white transition duration-200"
              >
                info@deetyasoft.com
              </a>
              ,{" "}
              <a
                href="mailto:support@ivrguru.com"
                className="no-underline text-gray-300 hover:text-white transition duration-200"
              >
                support@ivrguru.com
              </a>
            </span>
          </div>

          {/* Web */}
          <div className="flex items-start gap-2 hover:text-white transition duration-200 cursor-pointer">
            <FontAwesomeIcon icon={faGlobe} className="mt-1 text-gray-300" />
            <span className="text-gray-300 text-[15px] group-hover:text-white">
              <strong>Web:</strong>{" "}
              <a
                href="http://www.deetyasoft.com/"
                target="_blank"
                rel="noopener noreferrer"
                className="no-underline text-gray-300 hover:text-white transition duration-200"
              >
                www.deetyasoft.com
              </a>
            </span>
          </div>
        </div>

        {/* Map Section */}
        <div>
          <h4 className="text-lg font-semibold mb-2 ">Our Location</h4>
          <div className=" md:w-20 w-20  h-[2px] bg-main1 mb-3  rounded-full" />
          <div className="w-full h-52 overflow-hidden rounded-md">
            <iframe
              title="IVR Guru Location"
              src="https://www.google.com/maps?q=FF-06,+First+Floor,+Mahaluxmi+Square,+Indirapuram,+Ghaziabad,+Uttar+Pradesh+-+201014&output=embed"
              className="w-full h-full border-0"
              allowFullScreen=""
              loading="lazy"
              referrerPolicy="no-referrer-when-downgrade"
            ></iframe>
          </div>
          <h4 className="py-2 border-b text-base  ">Follow us on </h4>

          <div className="">
            <p className=" text-sm no-underline list-none"></p>

            <div className="flex py-1 space-x-3">
              {socialLinks.map((link, index) => (
                <a
                  key={index}
                  href={link.href}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="w-9 h-9 flex items-center justify-center rounded-full bg-transparent text-white border border-white transition-all duration-300 relative group overflow-hidden"
                >
                  {/* Background Animation */}
                  <span
                    className={`absolute inset-0 rounded-full ${link.bg} scale-0 transition-transform duration-300 group-hover:scale-100`}
                  ></span>

                  {/* Icon */}
                  <FontAwesomeIcon
                    icon={link.icon}
                    className="text-white text-lg transition-all duration-300 relative z-10 group-hover:text-white"
                  />
                </a>
              ))}
            </div>
          </div>
        </div>
      </div>

      {/* Bottom Strip */}
      <div className="border-t  border-white px-6 md:px-7 py-4 text-gray-300 text-sm flex justify-between md:items-center flex-col md:flex-row">
        <p>
          © {new Date().getFullYear()} All Rights Reserved , Deetya Soft Pvt
          Ltd.
        </p>

        <div className="flex gap-4 mt-2 md:mt-0">
          <Link
            to="/terms-and-conditions"
            className="no-underline text-gray-300 hover:text-white cursor-pointer transition duration-200"
          >
            Terms & Conditions.
          </Link>
          <Link
            to="/privacy-policy"
            className="no-underline text-gray-300 hover:text-white cursor-pointer transition duration-200"
          >
            Privacy Policy
          </Link>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
